import { IFormService } from "../../service/form/FormService";

export default class AddNewDraftFormVersionInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(
    reportingPeriodApplicantId: number,
    reportingPeriodFormTypeId: number,
    formId?: number
  ) {
    return this.formService.addNewDraftFormVersion(
      reportingPeriodApplicantId,
      reportingPeriodFormTypeId,
      formId
    );
  }
}
